import React, { useState } from "react";
import { Button, Icon, Modal, Radio } from "antd";
import { AdsSortOptionText, AdsSortOption } from "../../../models";
import SortOptionToggle from "./SortOptionToggle";
import SortOptionItem from "./SortOptionItem";
import styles from "./sortOptionMobile.scss";
import HelmetComponent from "../../../utils/HelmetHelper";

interface SortOptionMobileProps {
  onSortClick: (value: string) => void;
  selectedOption: number;
}

const SortOptionMobile = (props: SortOptionMobileProps) => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [currentOption, setCurrentOption] = useState(null);

  const modalStyle = { top: 0, left: 0, margin: 0, paddingBottom: 0 };
  const modalBodyStyle = { padding: 0 };

  const showModal = () => {
    const { selectedOption } = props;

    setIsShowModal(true);
    setCurrentOption(selectedOption);
  };

  const offModal = () => setIsShowModal(false);

  const handleSortClick = () => {
    const { onSortClick } = props;

    offModal();

    onSortClick(currentOption);
  };

  const handleSortItemClick = value => {
    if (currentOption === value) {
      return;
    }
    setCurrentOption(value);
  };

  return (
    <React.Fragment>
      <SortOptionToggle onToggleModal={showModal} />
      <Modal
        destroyOnClose
        visible={isShowModal}
        footer={null}
        style={modalStyle}
        bodyStyle={modalBodyStyle}
        wrapClassName={styles.modal}
        closable={false}
        className={styles.modalInner}
      >
        <HelmetComponent
          title={`${"Sortiraj"} | ${"INDEX OGLASI"}`}
        />
        <div className={styles.modalHeader}>
          <span>{"Sortiraj"}</span>
          <Icon onClick={offModal} type="close" />
        </div>
        <Radio.Group value={currentOption} className={styles.radioGroup}>
          {AdsSortOptionText.map(option => (
            <SortOptionItem
              key={option.value}
              option={option}
              onSortItemClick={handleSortItemClick}
            />
          ))}
        </Radio.Group>
        <div className={styles.modalFooter}>
          <Button className={styles.cancelBtn} onClick={offModal}>
            {"Odustani"}
          </Button>
          <Button className={styles.okBtn} onClick={handleSortClick}>
            {"Sortiraj"}
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

SortOptionMobile.defaultProps = {
  selectedOption: AdsSortOption.DateDesc
};

export default SortOptionMobile;



// WEBPACK FOOTER //
// ./src/components/SortOption/SortOptionMobile/index.tsx